import React from 'react';
import { Form, Col, Row, Button, Spinner } from 'react-bootstrap';
import { Typeahead } from 'react-bootstrap-typeahead';
import Multiselect from 'multiselect-react-dropdown';
import { MultiSelect } from "react-multi-select-component";
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory, { PaginationProvider, PaginationListStandalone } from 'react-bootstrap-table2-paginator';
//import filterFactory from 'react-bootstrap-table2-filter';
import axios, { AxiosRequestConfig } from 'axios';
import moment from 'moment';
import { Constants } from "../../constants";
import SiteMenu from "../menu";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import '../../App.css';
import ReactGA from "react-ga4";

const columns = [
    {
        dataField: 'VisitDate',
        text: 'Date',
        sort: true,
        formatter: dateFormat,
        headerStyle: (colum, colIndex) => {
            return { width: '120px', textAlign: 'center' };
        }
    },
    {
        dataField: 'BuildingName',
        text: 'Building',
        sort: true,
        headerStyle: (colum, colIndex) => {
            return { width: '250px', textAlign: 'center' };
        }
    },
    {
        dataField: 'VisitType',
        text: 'Service Type',
        sort: true,
        headerStyle: (colum, colIndex) => {
            return { width: '160px', textAlign: 'center' };
        }
    },
    {
        dataField: 'ServiceCallID',
        text: 'Service Call ID',
        sort: true,
        headerStyle: (colum, colIndex) => {
            return { width: '160px', textAlign: 'center' };
        }
    },
    {
        dataField: 'Technician',
        text: 'Technician',
        sort: true,
        headerStyle: (colum, colIndex) => {
            return { width: '160px', textAlign: 'center' };
        }
    },
    {
        dataField: 'ServiceNotes',
        text: 'Service Notes',
        headerStyle: (colum, colIndex) => {
            return { textAlign: 'center' };
        }
    }];

function dateFormat(value, row, index) {
    return moment(value).format('MM/DD/YYYY');
}

class BuildingServiceView extends React.Component {

    constructor(props) {
        super(props);

        let userExists = !(props.location.state == null || props.location.state.user == null);

        this.state = {
            user: userExists ? props.location.state.user : {},
            page: 1,
            visits: [],
            selected: [],
            totalSize: 0,
            sizePerPage: 20,
            buildings: [],
            selectedBuildings: [],
            selectedVisitTypes: [],
            selectedServiceTypes: [],
            startDate: '',
            endDate: '',
            visitType: '',
            serviceType: '',
            loading: false,
            downloadingCSV: false,
            serviceDescription: ''

        };
        this.handleTableChange = this.handleTableChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleClear = this.handleClear.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.handleBuildingSelectionChange = this.handleBuildingSelectionChange.bind(this);
        this.handleVisitTypeChange = this.handleVisitTypeChange.bind(this);
        this.handleServiceTypeChange = this.handleServiceTypeChange.bind(this); 
        this.downloadSelected = this.downloadSelected.bind(this);
        this.showButton = this.showButton.bind(this);
        this.downloadCSV = this.downloadCSV.bind(this);

        this.loadingSpinner = this.loadingSpinner.bind(this);

        this.buildingDropdown = React.createRef();
        this.visitType = React.createRef();
        this.serviceType = React.createRef();
        this.startDate = React.createRef();
        this.endDate = React.createRef();
    }

    componentDidMount() {
        axios.get(`${Constants.apiURL}/api/Order/GetBuildingsByUser`, {
            params: {
                user: this.state.user.username
            }
        }).then(response => {
            console.log(response);
            if (response.data) {
                var x = response.data.map(function (item) {
                    item.buildingName = item.buildingName;
                    item.address = item.address;
                    item.label = item.buildingName + " | " + item.address;
                    item.value = item.buildingKey;
                    return item;
                });
                this.setState({ buildings: response.data },
                    () => this.handleTableChange('', this.state));
            }
        }).catch((response) => {
            if (response.status === 401) {
                this.props.history.push({
                    pathname: '/'
                });
            }
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({ loading: false });
            console.log('request failed', response)
        });
    }

    loadingSpinner() {
        if (this.state.loading) {
            return <div style={{ display: 'flex', justifyContent: 'center', marginTop: 5 }}>
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
            </div>;
        }
        else {
            return 'No records.';
        }
    };

    handleVisitTypeChange(event) {
        console.log(event);
        let selectedVisitTypeString = event.map((item) => {
            return item.value
        }).join(';');
        console.log(selectedVisitTypeString);
        this.setState({
            selectedVisitTypes: event,
            visitType: selectedVisitTypeString,
            page: 1
        }, () => this.handleTableChange("search", this.state));

        /*var visits = selected.map(function (sel) {
            return sel.value;
        }).join(';');
        this.setState({ visitType: visits }, function () {
            this.handleTableChange("search", this.state)
        });*/
    }


    handleServiceTypeChange(event) {
        console.log(event);
        let selectedServiceTypeString = event.map((item) => {
            return item.value
        }).join(';');

        this.setState({
            selectedServiceTypes: event,
            serviceType: selectedServiceTypeString, // Use serviceDescription here
            page: 1
        }, () => this.handleTableChange("search", this.state));
    }



    handleClear() {
        this.startDate.current.value = "";
        this.endDate.current.value = "";

        this.setState({
            visits: [],
            selected: [],
            selectedBuildings: [],
            selectedVisitTypes: [],
            selectedServiceTypes: [],
            buildingSearchString:'',
            totalSize: 0,
            page:1,
            visitType: '',
            serviceType: '',
            startDate: '',
            endDate: ''
        }, () => this.handleTableChange("search", this.state));

    }

    handleSearch(event) {
        event.preventDefault();
        this.handleTableChange("search", this.state);
    }

    handleFilterChange(event) {
        let input = this.state;
        input[event.target.name] = event.target.value;
        input.page = 1;
        this.setState({
            input
        }, function () {
            this.handleTableChange("search", this.state)
        });
    }


    handleBuildingSelectionChange(event) {
        console.log(event);
        let selectedBuildingString = event.map((item) => {
            return item.value
        }).join(',');
        console.log(selectedBuildingString);
        this.setState({
            selectedBuildings: event,
            buildingSearchString: selectedBuildingString,
            page: 1
        }, () => this.handleTableChange("search", this.state));
    }

    handleTableChange = (type, { page, sizePerPage, sortField, sortOrder }) => {
        ReactGA.event({
            category: 'Search',
            action: 'Building Service Log',
            label: 'Building Service Log Search'
        });
        this.setState({
            loading: true,
            visits: [],
            page,
            sortOrder,
            sortField,
            sizePerPage
        },
            function () {

                axios.get(`${Constants.apiURL}/api/Order/GetSiteServiceVisitsByBuildingSort`, {
                    params: {
                        user: this.state.user.username,
                        page: this.state.page,
                        pageSize: this.state.sizePerPage,
                        visitType: this.state.visitType,
                        serviceType: this.state.serviceType,
                        buildingSearchString: this.state.buildingSearchString,
                        startDate: this.state.startDate,
                        endDate: this.state.endDate,
                        isAdmin: false,
                        serviceDescription: this.state.serviceDescription,
                        sortField: this.state.sortField,
                        sortOrder: this.state.sortOrder
                    }
                }).then(response => {
                    console.log(response);
                    if (response.data) {
                        this.setState(() => ({
                            loading:false,
                            visits: JSON.parse(response.data.data),
                            totalSize: response.data.rowcount,
                            selected: []
                        }));
                    }
                }).catch((response) => {
                    if (response.response.status === 401) {
                        this.props.history.push({
                            pathname: '/'
                        });
                    }
                    // ? Show to user that request is failed
                    this.setState({ errors: [response] })
                    this.setState({ loading: false });
                    console.log('request failed', response)
                });
            });
    }

    showCSVButton() {
        if (this.state.downloadingCSV) {
            return <Button style={{ backgroundColor: '#1F419B' }} variant="primary" type="submit">
                <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true" />
                <span className="visually-hidden">Downloading...</span>
            </Button>
        }
        else {
            return <Button style={{ backgroundColor: '#1F419B' }} variant="primary" type="submit" onClick={this.downloadCSV}>
                Export as CSV
            </Button>
        }
    }

    showButton() {
        if (this.state.loading) {
            return <Button style={{ marginLeft: '10px', backgroundColor: '#1F419B' }} variant="primary" type="submit">
                <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true" />
                <span className="visually-hidden">Loading...</span>
            </Button>
        }
        else {
            return <Button style={{ marginLeft: '10px', backgroundColor: '#1F419B' }} variant="primary" type="submit" onClick={this.downloadSelected}>
                Download Selected
            </Button>
        }
    }

    downloadSelected(event) {
        if (this.state.selected.length == 0) {
            alert('No building selected. Please select at lease one building to download.');
            return;
        }
        this.setState({ loading: true });
        axios.post(`${Constants.apiURL}/api/Order/DownloadSiteVisits`, {
            user: this.state.user.username,
            visits: this.state.selected
        }, {
            'headers': {
                'content-type': 'application/json'
            },
            responseType: 'blob'
        }).then(response => {
            console.log(response);
            this.setState({ loading: false });
            if (response.data) {
                ReactGA.event({
                    category: 'Download',
                    action: 'ServiceTicketDownload',
                    label: 'Building Log - Download Service Ticket'
                });
                let blob = new Blob([response.data], { type: 'application/zip' }),
                    downloadUrl = window.URL.createObjectURL(blob),
                    filename = "",
                    disposition = response.headers["content-disposition"];
                console.log(disposition);

                if (disposition && disposition.indexOf("attachment") !== -1) {
                    let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/,
                        matches = filenameRegex.exec(disposition);

                    if (matches != null && matches[1]) {
                        filename = matches[1].replace(/['"]/g, "");
                    }
                }
                else {
                    alert('We are unable to locate the selected document(s). Please email us at clientportal@boland.com for help with this issue.');
                    return;
                }

                let a = document.createElement("a");
                if (typeof a.download === "undefined") {
                    window.location.href = downloadUrl;
                } else {
                    a.href = downloadUrl;
                    a.download = filename;
                    document.body.appendChild(a);
                    a.click();
                }
                downloadUrl.revokeObjectURL();
            }
        }).catch((response) => {
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({ loading: false });
            console.log('request failed', response)
        });
    }

    downloadCSV(event) {
        this.setState({ downloadingCSV: true });
        axios.get(`${Constants.apiURL}/api/Order/DownloadBuildingSiteServiceVisitReport`, {
            params: {
                user: this.state.user.username,
                visitType: this.state.visitType,
                serviceType: this.state.serviceType,
                buildingSearchString: this.state.buildingSearchString,
                startDate: this.state.startDate,
                endDate: this.state.endDate
            },
            responseType: 'blob'
        }).then(response => {
            ReactGA.event({
                category: 'Download',
                action: 'Building Service Log CSV',
                label: 'Building Service Log'
            });
            this.setState({ downloadingCSV: false });
            if (response.data) {
                if (response.data == 'No files found.') return;
                let blob = new Blob([response.data], { type: 'text/csv' }),
                    downloadUrl = window.URL.createObjectURL(blob),
                    filename = "",
                    disposition = response.headers["content-disposition"];

                if (disposition && disposition.indexOf("attachment") !== -1) {
                    let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/,
                        matches = filenameRegex.exec(disposition);

                    if (matches != null && matches[1]) {
                        filename = matches[1].replace(/['"]/g, "");
                    }
                }
                else {
                    alert('We are unable to locate the selected document(s). Please email us at clientportal@boland.com for help with this issue.');
                    return;
                }

                let a = document.createElement("a");
                if (typeof a.download === "undefined") {
                    window.location.href = downloadUrl;
                } else {
                    a.href = downloadUrl;
                    a.download = filename;
                    document.body.appendChild(a);
                    a.click();
                }
                downloadUrl.revokeObjectURL();
            }
        }).catch((response) => {
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({ downloadingCSV: false });
            console.log('request failed', response)
        });
    }

    handleSelect = (row, isSelect) => {
        let allow = true;
        let CurrentSelected = [];
        if (isSelect) {
            CurrentSelected = [...this.state.selected, row];
        } else {
            allow = false;
            CurrentSelected = this.state.selected.filter(x => x !== row);
        }
        this.state.selected = CurrentSelected;
    }

    handleSelectAll = (isSelect, rows) => {
        let allow = true;
        let CurrentSelected = [];
        if (isSelect) {
            CurrentSelected = rows;
        } else {
            CurrentSelected = [];
        }
        this.state.selected = CurrentSelected;
    }

    render() {
        const { data, totalSize, page, sizePerPage, buildings, selectedBuildings, selectedVisitTypes, selectedServiceTypes } = this.state;
        const selectRow = {
            mode: 'checkbox',
            clickToSelect: true,
            onSelect: this.handleSelect,
            onSelectAll: this.handleSelectAll,
            style: { backgroundColor: '#D2D9EB' },
            headerColumnStyle: {
                backgroundColor: '#1F419B'
            }
        };
        const defaultSorted = [{
            dataField: 'CreatedDate',
            order: 'desc'
        }];

        const pagination = {
            custom: true,
            totalSize: totalSize,
            page: page,
            sizePerPage: sizePerPage
        };
        const customValueRenderer = (selected, _options) => {
            return selected.length
                ? selected.map(({ label }) => label + ", ").join('').replace(/, $/, '')
                : "Filter by building";
        };
        const customValueRendererVisitTypes = (selected, _options) => {
            return selected.length
                ? selected.map(({ label }) => label + ", ").join('').replace(/, $/, '')
                : "Filter by visit type";
        };
        const customValueRendererServiceTypes = (selected, _options) => {
            return selected.length
                ? selected.map(({ label }) => label + ", ").join('').replace(/, $/, '')
                : "Filter by service type";
        };       return (
            <div class="site_visit building_view">
                <SiteMenu user={this.state.user} currentPage='buildingServiceView' />
                <Form onSubmit={this.handleSearch} className="mb-3">

                    <Form.Group as={Row} controlId="searchForm" style={{ padding: '10px 10px 0px 10px', justifyContent: 'right' }}>
                        <Col md="auto" sm="auto" xs="auto">
                            <Form.Label class='padding_left_zero_xs' style={{ paddingBottom: 0, marginBottom: 0, verticalAlign: 'middle', fontWeight: 'bold', fontSize: '21px', color: '#1F419B' }}>BUILDING SERVICE LOG</Form.Label>
                        </Col>
                        <Col width="100%">
                        </Col>
                        <Col md="auto">
                            <MultiSelect
                                style={{ width: '300px' }}
                                className="multiselect sm"
                                options={buildings}
                                onChange={this.handleBuildingSelectionChange}
                                labelledBy="Select"
                                value={selectedBuildings}
                                valueRenderer={customValueRenderer}
                                hasSelectAll={false}
                            />
                        </Col>
                        <Col md="auto">
                            <MultiSelect
                                style={{ width: '300px' }}
                                className="multiselect sm"
                                options={[
                                    { Id: 1, value: 'CONTRACT MAINTENANCE', label: 'CONTRACT MAINTENANCE' },
                                    { Id: 2, value: 'NEW EQUIPMENT STARTUP & WARRANTY', label: 'NEW EQUIPMENT STARTUP & WARRANTY' },
                                    { Id: 3, value: 'QUOTED SERVICE', label: 'QUOTED SERVICE' },
                                    { Id: 4, value: 'SERVICE CALL', label: 'SERVICE CALL' },
                                    { Id: 5, value: 'PRODUCT DEFECT', label: 'PRODUCT DEFECT' },
                                    { Id: 6, value: 'TRANE FACTORY WARRANTY', label: 'TRANE FACTORY WARRANTY' }
                                ]}
                                onChange={this.handleVisitTypeChange}
                                labelledBy="Select"
                                value={selectedVisitTypes}
                                valueRenderer={customValueRendererVisitTypes}
                                hasSelectAll={false}
                            />
                        </Col>
                        <Col md="auto">
                            <MultiSelect
                                style={{ width: '200px' }}
                                className="multiselect sm"
                                options={[
                                    { Id: 1, value: 'Chiller', label: 'Chiller' },
                                    { Id: 2, value: 'Tracer', label: 'Tracer' },
                                    { Id: 3, value: 'Water Treatment', label: 'Water Treatment' }
                                ]}
                                onChange={this.handleServiceTypeChange}
                                labelledBy="Select"
                                value={selectedServiceTypes}
                                valueRenderer={customValueRendererServiceTypes}
                                hasSelectAll={false}
                            />
                        </Col>

                        <Col md={2} >
                            <Form.Group as={Row} className="mb-3" controlId="startDate" style={{}}>
                                <Form.Label style={{ alignSelf: 'center', textAlign: 'right', padding: 0 }} column md={3} size="sm">Start Date</Form.Label>
                                <Col md={9}>
                                    <Form.Control ref={this.startDate} size="sm" type="date" min={moment('2019-01-01').format('yyyy-MM-DD')} name="startDate" value={this.state.startDate} onChange={this.handleFilterChange}
                                        /*disabled={Object.keys(this.state.selectedBuilding).length == 0}*/ />
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3" controlId="endDate">
                                <Form.Label style={{ alignSelf: 'center', textAlign: 'right', padding: 0 }} column md={3} size="sm">End Date</Form.Label>
                                <Col md={9}>
                                    <Form.Control ref={this.endDate} size="sm" type="date" min={moment('2019-01-01').format('yyyy-MM-DD')} name="endDate" value={this.state.endDate} onChange={this.handleFilterChange}
                                        /*disabled={Object.keys(this.state.selectedBuilding).length == 0}*/ />
                                </Col></Form.Group>
                        </Col>
                        <Col md="auto" sm="auto" xs="auto" className="button_first" style={{ paddingLeft: 0 }}>
                            <Button style={{ backgroundColor: '#1F419B' }} type="submit" size="sm">
                                Search
                            </Button>
                        </Col>
                        <Col md="auto" sm="auto" xs="auto" style={{ paddingLeft: 0 }}>
                            <Button size="sm" onClick={this.handleClear} variant="secondary" >
                                Clear
                            </Button>
                        </Col>
                    </Form.Group>
                </Form>
                <PaginationProvider pagination={paginationFactory(pagination)}>
                    {({
                        paginationProps,
                        paginationTableProps
                    }) => (
                        <div>
                            <BootstrapTable
                                bootstrap4
                                remote
                                keyField="Id"
                                selectRow={selectRow}
                                wrapperClasses="building_service_table table-responsive"
                                defaultSorted={defaultSorted}
                                data={this.state.visits}
                                columns={columns}
                                onTableChange={this.handleTableChange}
                                noDataIndication={() =>
                                    <Form.Label style={{ fontSize: '16px', fontStyle: 'italic' }}>
                                        Service notes for this building have not yet been completed.
                                    </Form.Label>}
                                striped
                                hover
                                {...paginationTableProps}
                            />
                            <Form.Group as={Row} controlId="bolandButtons" style={{ padding: '0px 0px 0px 0px', marginRight: 0 }}>
                                <Col md="auto" sm="auto" xs="auto">
                                    {this.showButton()}
                                </Col>
                                <Col md="auto" sm="auto" xs="auto" style={{paddingLeft:0}}>
                                    {this.showCSVButton()}
                                </Col>
                                <Col width='100%' />
                                <Col md="auto" sm="auto" xs="auto"
                                    style={{ paddingRight: '10px' }} >
                                    <PaginationListStandalone
                                        {...paginationProps}
                                    />
                                </Col>
                            </Form.Group>
                        </div>
                    )
                    }
                </PaginationProvider>
            </div>
        );
    }
}

export default BuildingServiceView;